export type DragSession =
    | { readonly kind: "catalog"; readonly componentId: string; readonly sizeU: number }
    | {
          readonly kind: "placement";
          readonly placementId: string;
          readonly componentId: string;
          readonly sizeU: number;
      }
    | {
          readonly kind: "placement-group";
          readonly anchorPlacementId: string;
          readonly anchorSizeU: number;
          readonly items: readonly {
              readonly placementId: string;
              readonly componentId: string;
              readonly sizeU: number;
              readonly relativeStartU: number;
          }[];
      };

let activeSession: DragSession | null = null;

export function setDragSession(session: DragSession | null): void {
    activeSession = session;
}

export function getDragSession(): DragSession | null {
    return activeSession;
}
